<script>
export default {
  name: 'AppTabs2',
  props: ['tabs'],
  methods: {
    isExactActive(tab) {
      // fix issue that the `router-link-active-exact` is returned only if there is no diff also in params
      return tab.routeName === this.$route.name;
    }
  }
};
</script>

<template>
  <div>
    <nav class="tabs">
      <router-link
        v-for="tab in tabs"
        :key="tab.name"
        :to="{ name: tab.routeName, params: { id: tab.id } }"
        :class="isExactActive(tab) && 'router-link-exact'"
        class="tab"
        >{{ tab.name }}
      </router-link>
    </nav>
    <slot>
      <!-- Use slot for more flexibility -->
      <section class="panel">
        <router-view />
      </section>
    </slot>
  </div>
</template>

<style lang="scss" scoped>
.tabs {
  margin-top: 30px;

  .tab {
    display: inline-block;
    padding: 12px;
    width: 130px;
    text-align: center;
    font-size: 13px;
    font-weight: 700;
    background: var(--gray-light-5);
    color: var(--purple-light-3);
    border-radius: 8px 8px 0 0;
    transition: 0.15s ease-out;

    &.router-link-exact {
      background: #fcfdff;
      color: var(--primary-color);
    }

    &:hover {
      color: var(--primary-color);
    }
  }
}

.panel {
  margin-top: 0 !important;
  border-top-left-radius: 0 !important;
}
</style>
